{
  "comment": "Maps the untyped check output string onto a verdict. Assessment tools do not agree on a vocabulary and the report carries no type information, so this mapping is data rather than code: supporting a new tool's vocabulary is an edit here, not a release. Values are compared lowercased and trimmed. Anything absent resolves to unknown and is surfaced in the data quality view rather than guessed at. 'toolError' lists outputs that report the tool itself failing; such a check says nothing about the software, so it resolves to unknown and is reported as a tool failure, not as an unrecognised value.",
  "pass": [
    "true",
    "valid",
    "secure",
    "yes",
    "ok",
    "pass",
    "passed",
    "success",
    "succeeded",
    "present",
    "found",
    "compliant"
  ],
  "fail": [
    "false",
    "invalid",
    "insecure",
    "no",
    "fail",
    "failed",
    "failure",
    "absent",
    "missing",
    "not found",
    "non-compliant"
  ],
  "notApplicable": [
    "not applicable",
    "n/a",
    "na",
    "notapplicable",
    "not_applicable",
    "inapplicable"
  ],
  "toolError": ["error"]
}
